import { createFileRoute } from "@tanstack/react-router";
import { BookingProvider } from "@/components/site/booking-context";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { MobileBookingBar } from "@/components/site/MobileBookingBar";
import {
  ContactFAQ,
  ContactFinalCTA,
  ContactForm,
  ContactHero,
  ContactIntro,
  ContactMethods,
  ContactQuickLinks,
  LocationSection,
} from "@/components/site/contact";
import { heroPreloadLink } from "@/data/optimized-images";
import { contactFaqs, resort } from "@/data/resort";
import { absoluteUrl } from "@/lib/site";
import heroMainAsset from "@/assets/auburn-hero-main.webp.asset.json";


const title = "Contact Auburn RV Resort | Auburn, California";
const description =
  "Contact Auburn RV Resort in Auburn, California. Call 530-889-8878, send us a message, get directions or request RV site availability online.";
const ogImage = `https://auburnrvresort.com${heroMainAsset.url}`;


const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LodgingBusiness", "Campground"],
      name: resort.name,
      description,
      telephone: resort.phone,
      email: resort.email,
      url: "/contact-us/",
      address: {
        "@type": "PostalAddress",
        streetAddress: resort.address.street,
        addressLocality: resort.address.city,
        addressRegion: resort.address.state,
        postalCode: resort.address.zip,
        addressCountry: "US",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: contactFaqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export const Route = createFileRoute("/contact-us")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:image", content: ogImage },
      { property: "og:image:width", content: "1322" },
      { property: "og:image:height", content: "936" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: ogImage },
    ],
    links: [{ rel: "canonical", href: absoluteUrl("/contact-us/") }, heroPreloadLink],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(schema) }],
  }),
  component: ContactUsPage,
});

function ContactUsPage() {
  return (
    <BookingProvider>
      <Navbar />
      <main>
        <ContactHero />
        <ContactMethods />
        <ContactIntro />
        <ContactForm />
        <LocationSection />
        <ContactQuickLinks />
        <ContactFAQ />
        <ContactFinalCTA />
      </main>
      <Footer />
      <MobileBookingBar />
    </BookingProvider>
  );
}
